var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 33,
    viewBox: "0 0 47 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_103_6842",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 34,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0173 0H46.7412V8.62817H13.0173V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_103_6842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8168 0.00292969L27.2899 0.576087L40.6451 3.56205L29.8661 6.73291L16.3013 3.05977L13.2568 3.74694L29.8168 8.39691L46.4753 3.77159L29.8168 0.00292969Z",
    fill: "#5CE1E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_103_6842",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 5,
    width: 17,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3755 5.47339H46.7444V32.5412H30.3755V5.47339Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_103_6842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3228 6.53016V21.8575L33.2757 27.3456V9.59933L30.8567 10.2711V32.5472L46.7418 23.3767V5.8584L44.3228 6.53016Z",
    fill: "#5CE1E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_103_6842",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 25,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34082 5.47339H28.7955V32.5412H4.34082V5.47339Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_103_6842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8914 5.80859V9.89465H14.7372C15.2733 9.89465 15.7048 10.3291 15.7048 10.8653C15.7048 11.3984 15.2733 11.8329 14.7372 11.8329H5.77619C5.39409 11.8329 5.08594 12.1441 5.08594 12.5232C5.08594 12.9053 5.39409 13.2134 5.77619 13.2134H18.5829C19.116 13.2134 19.5505 13.6479 19.5505 14.1841C19.5505 14.7172 19.116 15.1517 18.5829 15.1517H10.0102C9.63114 15.1517 9.31991 15.4598 9.31991 15.8419C9.31991 16.224 9.63114 16.5322 10.0102 16.5322H16.5799C17.113 16.5322 17.5475 16.9667 17.5475 17.5029C17.5475 18.0359 17.113 18.4704 16.5799 18.4704H11.6249C11.2458 18.4704 10.9346 18.7786 10.9346 19.1607C10.9346 19.5428 11.2458 19.8509 11.6249 19.8509H20.6012C21.1374 19.8509 21.5719 20.2854 21.5719 20.8185C21.5719 21.3547 21.1374 21.7892 20.6012 21.7892H12.8914V23.3762L28.7764 32.5467V10.2675L12.8914 5.80859Z",
    fill: "#38B6FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_103_6842",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 13,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.83887H12.2274V22.8272H0V7.83887Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_103_6842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8392 21.194H4.17234C3.80256 21.194 3.50366 21.4929 3.50366 21.8627C3.50366 22.2294 3.80256 22.5283 4.17234 22.5283H9.8392C10.209 22.5283 10.5079 22.2294 10.5079 21.8627C10.5079 21.4929 10.209 21.194 9.8392 21.194ZM7.00423 16.3221C7.00423 15.9554 6.70532 15.6535 6.33863 15.6535H0.668684C0.298905 15.6535 0 15.9554 0 16.3221C0 16.6919 0.298905 16.9908 0.668684 16.9908H6.33863C6.70532 16.9908 7.00423 16.6919 7.00423 16.3221ZM11.42 8.16235H5.75006C5.38337 8.16235 5.08446 8.46126 5.08446 8.82796C5.08446 9.19773 5.38337 9.49664 5.75006 9.49664H11.42C11.7898 9.49664 12.0887 9.19773 12.0887 8.82796C12.0887 8.46126 11.7898 8.16235 11.42 8.16235Z",
    fill: "#38B6FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.2afbd239af67840f5b83ade928cba4a0.svg";
export { ForwardRef as ReactComponent };